import { Injectable, signal, untracked } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  public showSpinner$ = signal<boolean>(false);

  public get loading(): boolean {
    return this.showSpinner$();
  }

  public set loading(value: boolean) {
    untracked(() => this.showSpinner$.set(value));
  }

  public show() {
    untracked(() => this.showSpinner$.set(true));
  }

  public hide() {
    untracked(() => this.showSpinner$.set(false));
  }
}
